export const scholarshipLOV = [
  { id: "nineth_grade", label: "9º Ano Fundamental", value: "nineth_grade" },
  { id: "fst_grade", label: "1º Ano Ensino Médio", value: "fst_grade" },
  { id: "scn_grade", label: "2º Ano Ensino Médio", value: "scn_grade" },
  { id: "trd_grade", label: "3º Ano Ensino Médio", value: "trd_grade" },
  { id: "graduate", label: "Ensino Superior", value: "graduate" },
];

export const statusLOV = [
  {
    id: "awaiting_signature",
    label: "Aguardando Assinatura",
    value: "awaiting_signature",
    color: "yellow",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
  {
    id: "signed",
    label: "Assinado",
    value: "signed",
    color: "blue",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
  {
    id: "active",
    label: "Ativo",
    value: "active",
    color: "green",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
  {
    id: "expired",
    label: "Encerrado",
    value: "expired",
    color: "grey",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
  {
    id: "revoked",
    label: "Rescindido",
    value: "revoked",
    color: "red",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
  {
    id: "cancelled",
    label: "Cancelado",
    value: "cancelled",
    color: "red",
    acceptedValues: [
      "awaiting_signature",
      "active",
      "revoked",
      "expired",
      "cancelled",
    ],
  },
];

export const techSheetContextLOV = {
  // SCHOOL
  SCHOOL_NAME: { label: "Nome da Escola", placeholder: "NOME DA ESCOLA" },
  SCHOOL_CNPJ: { label: "CNPJ da Escola", placeholder: "SS.SSS.SSS/SSSS-NN" },
  SCHOOL_DIRECTOR: {
    label: "Diretor(a) da Escola",
    placeholder: "NOME DO DIRETOR",
  },
  SCHOOL_ADDR_STREET: { label: "Rua da Escola", placeholder: "Rua de Exemplo" },
  SCHOOL_ADDR_NUMBER: { label: "Número da Escola", placeholder: "123" },
  SCHOOL_ADDR_COMPLEMENT: {
    label: "Complemento da Escola",
    placeholder: "Complemento",
  },
  SCHOOL_ADDR_CITY: { label: "Cidade da Escola", placeholder: "São Paulo" },
  SCHOOL_ADDR_STATE: { label: "Estado da Escola", placeholder: "São Paulo" },
  SCHOOL_ADDR_STATE_ABBR: {
    label: "Estado Abrv. da Escola",
    placeholder: "SP",
  },
  SCHOOL_ADDR_DISTRICT: { label: "Bairro da Escola", placeholder: "Centro" },
  SCHOOL_ADDR_ZIPCODE: { label: "CEP da Escola", placeholder: "0700000-00" },
  // GRANTOR
  GRANTOR_NAME: {
    label: "Nome do Concedente",
    placeholder: "NOME DO CONCEDENTE",
  },
  GRANTOR_TRADE_NAME: {
    label: "Nome Fantasia do Concedente",
    placeholder: "NOME FANTASIA DO CONCEDENTE",
  },
  GRANTOR_IE: {
    label: "Inscrição Estadual do Concedente",
    placeholder: "11.111.1111-1",
  },
  GRANTOR_CNPJ: {
    label: "CNPJ do Concedente",
    placeholder: "SS.SSS.SSS/SSSS-NN",
  },
  GRANTOR_ADDR_STREET: {
    label: "Rua do Concedente",
    placeholder: "Rua de Exemplo",
  },
  GRANTOR_ADDR_NUMBER: {
    label: "Número do Concedente",
    placeholder: "123",
  },
  GRANTOR_ADDR_COMPLEMENT: {
    label: "Complemento do Concedente",
    placeholder: "Complemento",
  },
  GRANTOR_ADDR_CITY: {
    label: "Cidade do Concedente",
    placeholder: "São Paulo",
  },
  GRANTOR_ADDR_STATE: {
    label: "Estado do Concedente",
    placeholder: "São Paulo",
  },
  GRANTOR_ADDR_STATE_ABBR: {
    label: "Estado Abrv. do Concedente",
    placeholder: "SP",
  },
  GRANTOR_ADDR_DISTRICT: {
    label: "Bairro do Concedente",
    placeholder: "Centro",
  },
  GRANTOR_ADDR_ZIPCODE: {
    label: "CEP do Concedente",
    placeholder: "0700000-00",
  },
  // INTEGRATOR
  INTEGRATOR_NAME: {
    label: "Nome do Integrador",
    placeholder: "NOME DO INTEGRADOR",
  },
  INTEGRATOR_TRADE_NAME: {
    label: "Nome Fantasia do Integrador",
    placeholder: "NOME FANTASIA DO INTEGRADOR",
  },
  INTEGRATOR_IE: {
    label: "Inscrição Estadual do Integrador",
    placeholder: "22.222.2222-2",
  },
  INTEGRATOR_CNPJ: {
    label: "CNPJ do Concedente",
    placeholder: "SS.SSS.SSS/SSSS-NN",
  },
  INTEGRATOR_ADDR_STREET: {
    label: "Rua do Integrador",
    placeholder: "Rua de Exemplo",
  },
  INTEGRATOR_ADDR_NUMBER: {
    label: "Número do Integrador",
    placeholder: "123",
  },
  INTEGRATOR_ADDR_COMPLEMENT: {
    label: "Complemento do Integrador",
    placeholder: "Complemento",
  },
  INTEGRATOR_ADDR_CITY: {
    label: "Cidade do Integrador",
    placeholder: "São Paulo",
  },
  INTEGRATOR_ADDR_STATE: {
    label: "Estado do Integrador",
    placeholder: "São Paulo",
  },
  INTEGRATOR_ADDR_STATE_ABBR: {
    label: "Estado Abrv. do Integrador",
    placeholder: "SP",
  },
  INTEGRATOR_ADDR_DISTRICT: {
    label: "Bairro do Integrador",
    placeholder: "Centro",
  },
  INTEGRATOR_ADDR_ZIPCODE: {
    label: "CEP do Integrador",
    placeholder: "0700000-00",
  },
  INTEGRATOR_STAMP: {
    label: "Carimbo do Integrador",
    placeholder: "/stamp_placeholder.png",
  },
  // TRAINEE
  TRAINEE_NAME: {
    label: "Nome do Estagiário",
    placeholder: "NOME DO ESTAGIÁRIO",
  },
  TRAINEE_IS_MINOR: {
    label: "Estagiário é Menor de Idade?",
    placeholder: true,
  },
  TRAINEE_BIRTH_DATE: {
    label: "Nascimento do Estagiário",
    placeholder: "01/01/2000",
  },
  TRAINEE_RGIE: {
    label: "Documento de Registro do Estagiário",
    placeholder: "11.111.111-8",
  },
  TRAINEE_CPFCNPJ: {
    label: "CPF/CNPJ do Estagiário",
    placeholder: "111.111.111/11",
  },
  TRAINEE_ADDR_STREET: {
    label: "Rua do Estagiário",
    placeholder: "Rua de Exemplo",
  },
  TRAINEE_ADDR_NUMBER: {
    label: "Número do Estagiário",
    placeholder: "123",
  },
  TRAINEE_ADDR_COMPLEMENT: {
    label: "Complemento do Estagiário",
    placeholder: "Complemento",
  },
  TRAINEE_ADDR_CITY: {
    label: "Cidade do Estagiário",
    placeholder: "São Paulo",
  },
  TRAINEE_ADDR_STATE: {
    label: "Estado do Estagiário",
    placeholder: "São Paulo",
  },
  TRAINEE_ADDR_STATE_ABBR: {
    label: "Estado Abrv. do Estagiário",
    placeholder: "SP",
  },
  TRAINEE_ADDR_DISTRICT: {
    label: "Bairro do Estagiário",
    placeholder: "Centro",
  },
  TRAINEE_ADDR_ZIPCODE: {
    label: "CEP do Estagiário",
    placeholder: "0700000-00",
  },
  TRAINEE_SCHOLARSHIP: {
    label: "Escolaridade do Estagiário",
    placeholder: "Ensino Superior",
  },
  TRAINEE_GRADUATION_COURSE: {
    label: "Curso Superior do Estagiário",
    placeholder: "Engenharia Civil",
  },
  // CONTRACT
  CONTRACT_INSURANCE_COMPANY: {
    label: "Companhia de Seguro do Contrato",
    placeholder: "Compania Seguro",
  },
  CONTRACT_POLICY_NUMBER: {
    label: "Número do Seguro do Contrato",
    placeholder: "111.111.111.111.111-1",
  },
  CONTRACT_START_DATE: {
    label: "Data de inicio do Contrato",
    placeholder: "01/01/2001",
  },
  CONTRACT_END_DATE: {
    label: "Data de encerramento do Contrato",
    placeholder: "01/01/2002",
  },
  CONTRACT_WORKING_SCHEDULE: {
    label: "Escala do Contrato",
    placeholder: "6x1",
  },
  CONTRACT_WORKING_SCHEDULE_TIME_PER_DAY: {
    label: "Escala do Contrato (em horas por dia)",
    placeholder: "5 horas",
  },
  CONTRACT_WORK_START_TIME: {
    label: "Horário de Inicio do Expediente do Contrato",
    placeholder: "09:00",
  },
  CONTRACT_WORK_END_TIME: {
    label: "Horário de Encerramento do Expediente do Contrato",
    placeholder: "16:00",
  },
  CONTRACT_INTERVAL_TIME: {
    label: "Quantidade de Tempo de Intervalo do Contrato",
    placeholder: "1 hora",
  },
  CONTRACT_SUPERVISOR_NAME: {
    label: "Supervisor do Estagiário",
    placeholder: "SUPERVISOR DO ESTAGIÁRIO",
  },
  CONTRACT_WAGE_AMOUNT: {
    label: "Valor da Bolsa Estágio Mensal",
    placeholder: "125,31",
  },
  CONTRACT_WAGE_UNABBR: {
    label: "Valor da Bolsa Estágio Mensal Por Extenso",
    placeholder: "CENTO E VINTE E CINCO REAIS E TRINTA E UM CENTAVOS",
  },
  CONTRACT_JOB_POSITION: {
    label: "Atividade/Função do Estagiário",
    placeholder: "AUXILIAR GERAL",
  },
  CONTRACT_REVOKED_AT: {
    label: "Data de Rescisão do Contrato",
    placeholder: "01/01/2001",
  },
  CONTRACT_EXTENSION_DATE: {
    label: "Data de Extensão do Contrato",
    placeholder: "01/01/2003",
  },
  CONTRACT_STATUS: {
    label: "Status do Contrato",
    placeholder: "active",
  },
  CONTRACT_ID: {
    label: "ID do Contrato",
    placeholder: 1,
  },
  CONTRACT_REVOCATION_REASON: {
    label: "Motivo da Rescisão do Contrato",
    placeholder: "Motivo da Rescisão",
  },
  VARS_PERIOD: {
    label: "Período da Avaliação",
    placeholder: "2001 - 1ª Semestre",
  },
  VARS_PERIOD_MONTHYEAR: {
    label: "Período (Mês/Ano)",
    placeholder: "05/2000",
  },
  VARS_FIELD_REMUNERATION: {
    label: "Bolsa Auxilio",
    placeholder: "20,00",
  },
  VARS_FIELD_REMUNERATION_REF: {
    label: "Bolsa Auxilio (Referência)",
    placeholder: "(30/30)",
  },
  VARS_FIELD_ADDENDUM: {
    label: "Adiantamento",
    placeholder: "20,00",
  },
  VARS_FIELD_ADDENDUM_REF: {
    label: "Adiantamento (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_VOUCHER: {
    label: "Vale",
    placeholder: "20,00",
  },
  VARS_FIELD_VOUCHER_REF: {
    label: "Vale (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_VOUCHER_SHOPPING: {
    label: "Vale Compras",
    placeholder: "20,00",
  },
  VARS_FIELD_VOUCHER_SHOPPING_REF: {
    label: "Vale Compras (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_ABSENCE: {
    label: "Faltas",
    placeholder: "20,00",
  },
  VARS_FIELD_ABSENCE_REF: {
    label: "Vale Compras (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_BONUS: {
    label: "Bônus",
    placeholder: "20,00",
  },
  VARS_FIELD_BONUS_REF: {
    label: "Bônus (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_REWARD: {
    label: "Gratificação",
    placeholder: "20,00",
  },
  VARS_FIELD_REWARD_REF: {
    label: "Gratificação (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_AWARD: {
    label: "Premiação",
    placeholder: "20,00",
  },
  VARS_FIELD_AWARD_REF: {
    label: "Premiação (Referência)",
    placeholder: "(1/12)",
  },
  VARS_FIELD_VACATIONS: {
    label: "Férias",
    placeholder: "20,00",
  },
  VARS_FIELD_VACATIONS_REF: {
    label: "Férias (Referência)",
    placeholder: "(1/12)",
  },
  VARS_PROVENTS_TOTAL: {
    label: "Total de Proventos",
    placeholder: "185,31",
  },
  VARS_DESCOUNTS_TOTAL: {
    label: "Total dos Descontos",
    placeholder: "80,00",
  },
  VARS_RECEIVE_TOTAL: {
    label: "Total a Receber",
    placeholder: "105,31",
  },

};
techSheetContextLOV.REPORT_CONTRACT_LIST = {
  label: "Lista de Contrato(s)",
  placeholder: new Array({
    SCHOOL_NAME: techSheetContextLOV.SCHOOL_NAME.placeholder,
    SCHOOL_CNPJ: techSheetContextLOV.SCHOOL_CNPJ.placeholder,
    SCHOOL_DIRECTOR: techSheetContextLOV.SCHOOL_DIRECTOR.placeholder,
    SCHOOL_ADDR_STREET: techSheetContextLOV.SCHOOL_ADDR_STREET.placeholder,
    SCHOOL_ADDR_NUMBER: techSheetContextLOV.SCHOOL_ADDR_NUMBER.placeholder,
    SCHOOL_ADDR_COMPLEMENT: techSheetContextLOV.SCHOOL_ADDR_COMPLEMENT.placeholder,
    SCHOOL_ADDR_CITY: techSheetContextLOV.SCHOOL_ADDR_CITY.placeholder,
    SCHOOL_ADDR_STATE: techSheetContextLOV.SCHOOL_ADDR_STATE.placeholder,
    SCHOOL_ADDR_STATE_ABBR: techSheetContextLOV.SCHOOL_ADDR_STATE_ABBR.placeholder,
    SCHOOL_ADDR_DISTRICT: techSheetContextLOV.SCHOOL_ADDR_DISTRICT.placeholder,
    SCHOOL_ADDR_ZIPCODE: techSheetContextLOV.SCHOOL_ADDR_ZIPCODE.placeholder,

    TRAINEE_NAME: techSheetContextLOV.TRAINEE_NAME.placeholder,
    TRAINEE_IS_MINOR: techSheetContextLOV.TRAINEE_IS_MINOR.placeholder,
    TRAINEE_BIRTH_DATE: techSheetContextLOV.TRAINEE_BIRTH_DATE.placeholder,
    TRAINEE_RGIE: techSheetContextLOV.TRAINEE_RGIE.placeholder,
    TRAINEE_CPFCNPJ: techSheetContextLOV.TRAINEE_CPFCNPJ.placeholder,
    TRAINEE_ADDR_STREET: techSheetContextLOV.TRAINEE_ADDR_STREET.placeholder,
    TRAINEE_ADDR_NUMBER: techSheetContextLOV.TRAINEE_ADDR_NUMBER.placeholder,
    TRAINEE_ADDR_COMPLEMENT: techSheetContextLOV.TRAINEE_ADDR_COMPLEMENT.placeholder,
    TRAINEE_ADDR_CITY: techSheetContextLOV.TRAINEE_ADDR_CITY.placeholder,
    TRAINEE_ADDR_STATE: techSheetContextLOV.TRAINEE_ADDR_STATE.placeholder,
    TRAINEE_ADDR_STATE_ABBR: techSheetContextLOV.TRAINEE_ADDR_STATE_ABBR.placeholder,
    TRAINEE_ADDR_DISTRICT: techSheetContextLOV.TRAINEE_ADDR_DISTRICT.placeholder,
    TRAINEE_ADDR_ZIPCODE: techSheetContextLOV.TRAINEE_ADDR_ZIPCODE.placeholder,
    TRAINEE_SCHOLARSHIP: techSheetContextLOV.TRAINEE_SCHOLARSHIP.placeholder,
    TRAINEE_GRADUATION_COURSE: techSheetContextLOV.TRAINEE_GRADUATION_COURSE.placeholder,

    CONTRACT_INSURANCE_COMPANY: techSheetContextLOV.CONTRACT_INSURANCE_COMPANY.placeholder,
    CONTRACT_POLICY_NUMBER: techSheetContextLOV.CONTRACT_POLICY_NUMBER.placeholder,
    CONTRACT_START_DATE: techSheetContextLOV.CONTRACT_START_DATE.placeholder,
    CONTRACT_END_DATE: techSheetContextLOV.CONTRACT_END_DATE.placeholder,
    CONTRACT_WORKING_SCHEDULE: techSheetContextLOV.CONTRACT_WORKING_SCHEDULE.placeholder,
    CONTRACT_WORKING_SCHEDULE_TIME_PER_DAY: techSheetContextLOV.CONTRACT_WORKING_SCHEDULE_TIME_PER_DAY.placeholder,
    CONTRACT_WORK_START_TIME: techSheetContextLOV.CONTRACT_WORK_START_TIME.placeholder,
    CONTRACT_WORK_END_TIME: techSheetContextLOV.CONTRACT_WORK_END_TIME.placeholder,
    CONTRACT_INTERVAL_TIME: techSheetContextLOV.CONTRACT_INTERVAL_TIME.placeholder,
    CONTRACT_SUPERVISOR_NAME: techSheetContextLOV.CONTRACT_SUPERVISOR_NAME.placeholder,
    CONTRACT_WAGE_AMOUNT: techSheetContextLOV.CONTRACT_WAGE_AMOUNT.placeholder,
    CONTRACT_WAGE_UNABBR: techSheetContextLOV.CONTRACT_WAGE_UNABBR.placeholder,
    CONTRACT_JOB_POSITION: techSheetContextLOV.CONTRACT_JOB_POSITION.placeholder,
    CONTRACT_EXTENSION_DATE: techSheetContextLOV.CONTRACT_EXTENSION_DATE.placeholder,
    CONTRACT_STATUS: techSheetContextLOV.CONTRACT_STATUS.placeholder,
    CONTRACT_ID: techSheetContextLOV.CONTRACT_ID.placeholder,
    CONTRACT_REVOKED_AT: techSheetContextLOV.CONTRACT_REVOKED_AT.placeholder,
    CONTRACT_REVOCATION_REASON: techSheetContextLOV.CONTRACT_REVOCATION_REASON.placeholder,
  })
}

export const techSheetLabelTypeLOV = {
  CONTRACT: "contract",
  PERFORMANCE_EVAL: "performance_eval",
  PAYSLIP: "payslip",
  ACTIVITY_PLAN: "activity_plan",
  CONTRACT_EXTENSION: "contract_extension",
  AGREE_TERM: "agree_term",
  TERMINATION_TERM: "termination_term",
  LIST_TRAINEES_BY_COMPANY: "list_trainees_by_company",
  TERMINATION_CALC: "termination_calc",
  CONTRACT_DISMISSAL: "contract_dismissal",
};

const techSheetContextGroupByLOV = {
  SCHOOL: [
    "SCHOOL_NAME",
    "SCHOOL_CNPJ",
    "SCHOOL_DIRECTOR",
    "SCHOOL_ADDR_STREET",
    "SCHOOL_ADDR_NUMBER",
    "SCHOOL_ADDR_COMPLEMENT",
    "SCHOOL_ADDR_CITY",
    "SCHOOL_ADDR_STATE",
    "SCHOOL_ADDR_STATE_ABBR",
    "SCHOOL_ADDR_DISTRICT",
    "SCHOOL_ADDR_ZIPCODE",
  ],
  GRANTOR: [
    "GRANTOR_NAME",
    "GRANTOR_TRADE_NAME",
    "GRANTOR_IE",
    "GRANTOR_CNPJ",
    "GRANTOR_ADDR_STREET",
    "GRANTOR_ADDR_NUMBER",
    "GRANTOR_ADDR_COMPLEMENT",
    "GRANTOR_ADDR_CITY",
    "GRANTOR_ADDR_STATE",
    "GRANTOR_ADDR_STATE_ABBR",
    "GRANTOR_ADDR_DISTRICT",
    "GRANTOR_ADDR_ZIPCODE",
  ],
  INTEGRATOR: [
    "INTEGRATOR_NAME",
    "INTEGRATOR_TRADE_NAME",
    "INTEGRATOR_IE",
    "INTEGRATOR_CNPJ",
    "INTEGRATOR_ADDR_STREET",
    "INTEGRATOR_ADDR_NUMBER",
    "INTEGRATOR_ADDR_COMPLEMENT",
    "INTEGRATOR_ADDR_CITY",
    "INTEGRATOR_ADDR_STATE",
    "INTEGRATOR_ADDR_STATE_ABBR",
    "INTEGRATOR_ADDR_DISTRICT",
    "INTEGRATOR_ADDR_ZIPCODE",
    "INTEGRATOR_STAMP",
  ],
  TRAINEE: [
    "TRAINEE_NAME",
    "TRAINEE_IS_MINOR",
    "TRAINEE_BIRTH_DATE",
    "TRAINEE_RGIE",
    "TRAINEE_CPFCNPJ",
    "TRAINEE_ADDR_STREET",
    "TRAINEE_ADDR_NUMBER",
    "TRAINEE_ADDR_COMPLEMENT",
    "TRAINEE_ADDR_CITY",
    "TRAINEE_ADDR_STATE",
    "TRAINEE_ADDR_STATE_ABBR",
    "TRAINEE_ADDR_DISTRICT",
    "TRAINEE_ADDR_ZIPCODE",
    "TRAINEE_SCHOLARSHIP",
    "TRAINEE_GRADUATION_COURSE",
  ],
  CONTRACT: [
    "CONTRACT_INSURANCE_COMPANY",
    "CONTRACT_POLICY_NUMBER",
    "CONTRACT_START_DATE",
    "CONTRACT_END_DATE",
    "CONTRACT_WORKING_SCHEDULE",
    "CONTRACT_WORKING_SCHEDULE_TIME_PER_DAY",
    "CONTRACT_WORK_START_TIME",
    "CONTRACT_WORK_END_TIME",
    "CONTRACT_INTERVAL_TIME",
    "CONTRACT_SUPERVISOR_NAME",
    "CONTRACT_WAGE_AMOUNT",
    "CONTRACT_WAGE_UNABBR",
    "CONTRACT_JOB_POSITION",
    "CONTRACT_STATUS",
    "CONTRACT_ID",
  ],
  CONTRACT_EXTESION: ["CONTRACT_EXTENSION_DATE"],
  CONTRACT_REVOKED: ["CONTRACT_REVOKED_AT", "CONTRACT_REVOCATION_REASON"],
  PAYMENTS_FIELDS: [
    "VARS_FIELD_REMUNERATION",
    "VARS_FIELD_REMUNERATION_REF",
    "VARS_FIELD_ADDENDUM",
    "VARS_FIELD_ADDENDUM_REF",
    "VARS_FIELD_VOUCHER",
    "VARS_FIELD_VOUCHER_REF",
    "VARS_FIELD_VOUCHER_SHOPPING",
    "VARS_FIELD_VOUCHER_SHOPPING_REF",
    "VARS_FIELD_ABSENCE",
    "VARS_FIELD_ABSENCE_REF",
    "VARS_FIELD_BONUS",
    "VARS_FIELD_BONUS_REF",
    "VARS_FIELD_REWARD",
    "VARS_FIELD_REWARD_REF",
    "VARS_FIELD_VACATIONS",
    "VARS_FIELD_VACATIONS_REF",
    "VARS_FIELD_AWARD",
    "VARS_FIELD_AWARD_REF",
    "VARS_PROVENTS_TOTAL",
    "VARS_DESCOUNTS_TOTAL",
    "VARS_RECEIVE_TOTAL",
  ],
};

export const techSheetVariablesFromTypeLOV = {
  CONTRACT: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
  ],
  PAYSLIP: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
    // PAYMENTS FIELDS
    ...techSheetContextGroupByLOV.PAYMENTS_FIELDS,
    "VARS_PERIOD_MONTHYEAR",
  ],
  PERFORMANCE_EVAL: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
    "VARS_PERIOD",
  ],
  TERMINATION_CALC: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
    ...techSheetContextGroupByLOV.CONTRACT_REVOKED,
    // PAYMENTS FIELDS
    ...techSheetContextGroupByLOV.PAYMENTS_FIELDS,
  ],
  CONTRACT_DISMISSAL: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
    ...techSheetContextGroupByLOV.CONTRACT_REVOKED,
  ],
  CONTRACT_EXTESION: [
    // SCHOOL
    ...techSheetContextGroupByLOV.SCHOOL,
    // GRANTOR
    ...techSheetContextGroupByLOV.GRANTOR,
    // INTEGRATOR
    ...techSheetContextGroupByLOV.INTEGRATOR,
    // TRAINEE
    ...techSheetContextGroupByLOV.TRAINEE,
    // CONTRACT
    ...techSheetContextGroupByLOV.CONTRACT,
    ...techSheetContextGroupByLOV.CONTRACT_EXTESION,
  ],
};

export const techSheetTypeLOV = [
  {
    id: techSheetLabelTypeLOV.CONTRACT,
    label: "Contrato",
    variables: techSheetVariablesFromTypeLOV.CONTRACT,
  },
  {
    id: techSheetLabelTypeLOV.PERFORMANCE_EVAL,
    label: "Avaliação de Desempenho",
    variables: techSheetVariablesFromTypeLOV.PERFORMANCE_EVAL,
  },
  {
    id: techSheetLabelTypeLOV.PAYSLIP,
    label: "Holerite",
    variables: techSheetVariablesFromTypeLOV.PAYSLIP,
  },
  {
    id: techSheetLabelTypeLOV.ACTIVITY_PLAN,
    label: "Plano de Atividade",
    variables: techSheetVariablesFromTypeLOV.CONTRACT,
  },
  {
    id: techSheetLabelTypeLOV.CONTRACT_EXTENSION,
    label: "Prorrogação Contratual",
    variables: techSheetVariablesFromTypeLOV.CONTRACT_EXTESION,
  },
  {
    id: techSheetLabelTypeLOV.AGREE_TERM,
    label: "Termo de Concordância",
    variables: techSheetVariablesFromTypeLOV.CONTRACT,
  },
  {
    id: techSheetLabelTypeLOV.TERMINATION_TERM,
    label: "Termo de Rescisão",
    variables: techSheetVariablesFromTypeLOV.CONTRACT_DISMISSAL,
  },
  {
    id: techSheetLabelTypeLOV.LIST_TRAINEES_BY_COMPANY,
    label: "Relação de Estagiários por Empresa",
    variables: new Array(...[...techSheetContextGroupByLOV.INTEGRATOR,...techSheetContextGroupByLOV.GRANTOR],"REPORT_CONTRACT_LIST"),
  },
  {
    id: techSheetLabelTypeLOV.TERMINATION_CALC,
    label: "Calculo de Rescisão",
    variables: techSheetVariablesFromTypeLOV.TERMINATION_CALC,
  },
  {
    id: techSheetLabelTypeLOV.CONTRACT_DISMISSAL,
    label: "Carta de Dispensa",
    variables: techSheetVariablesFromTypeLOV.CONTRACT_DISMISSAL,
  },
];

export const workingScheduleLOV = [
  { label: "Escala 5x2", value: "5b2" },
  { label: "Escala 6x1", value: "6b1" },
];

export const isYesNoAllLOV = [
  { id: "Não", label: "Não", value: "Não" },
  { id: "Sim", label: "Sim", value: "Sim" },
  { id: "Todos", label: "Todos", value: "Todos" },
];

export const paginationLimit = 15;

export const queryParamsConstructor = ({
  limit,
  skip = 0,
  sortInfo = "",
  groupBy = "",
  filterValue,
}) => {
  const queryParams = {
    page: (limit + skip) / limit,
    pageSize: limit,
  };

  filterValue.forEach((filterElement) => {
    if (typeof filterElement?.name !== "undefined" && filterElement?.value) {
      if (
        filterElement?.name === "startDate" ||
        filterElement?.name === "endDate"
      ) {
        queryParams[filterElement.name] = new Date(
          filterElement?.value
        ).toLocaleDateString("fr-CA");
        // queryParams[filterElement.name] = format(new Date(filterElement.value), 'yyyy-MM-dd')
      } else if (filterElement?.name === "isActive") {
        let value = filterElement?.value;
        switch (value) {
          case "Sim":
            value = true;
            break;
          case "Não":
            value = false;
            break;
          default:
            value = null;
            break;
        }
        if (value !== null) {
          queryParams[filterElement.name] = value;
        }
      } else {
        queryParams[filterElement.name] = filterElement.value;
      }
    }
  });

  return queryParams;
};
